module.exports = __webpack_public_path__ + "static/emision_deuda-d6fed91d45e5e3dfea02d482139fdbe4.png";